import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

import PrivateAdminRoute from './guard/PrivateAdminRoute';
import Home from './client/pages/Home';
import Blog from './client/pages/Blog';
import Login from './client/pages/Login';
import ClientLayout from './client/ClientLayout';
import BlogDetails from './client/pages/BlogDetails';
import Register from './client/pages/Register';

import AdminLayout from  './admin/AdminLayout';
import ManageBlogs from './admin/pages/ManageBlogs';
import CreateBlog from './admin/pages/CreateBlog';
import EditBlog from './admin/pages/EditBlogs'
import Logout from './client/pages/Logout';
import ManageComments from './admin/pages/ManageComments';
import './App.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import CategoryManager from './admin/pages/CategoryManager';
import NotFoundPage from './client/components/NotFoundPage';
import FloatingChat from './client/components/FloatingChats';
import Download from './client/pages/Download';
import CarouselAdmin from './admin/pages/CarouselAdmin';
import CreateBlogTest from './admin/pages/CreateBlogText';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';

// IMPORTANT: Replace with your own Google Analytics Measurement ID
const GA_MEASUREMENT_ID = "G-4EGRF8SDN2"; 

// --- Component to Track Page Views ---
const TrackPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null; 
};

function App() {
  // Initialize GA once when the app loads
  useEffect(() => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }, []);


  return (
    <AuthProvider>
      <Router>
        <TrackPageViews/>
        <Routes>

          {/* Client Section */}
          <Route path="/" element={<ClientLayout />}>
            <Route index element={<Home />} /> {/* Home page */}
            <Route path="blogs" element={<Blog/>} /> {/* Blog post page */}
            <Route path='download' element={<Download/>} />
            <Route path="blog/:id" element={<BlogDetails />} /> 
            <Route path="login" element={<Login />} /> {/* Login page */}
            <Route path='logout' element={<Logout/>} />
            <Route path="register" element={<Register />} /> {/* Register page */}
          </Route>


          {/* Admin Section */}
          <Route element={<PrivateAdminRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<ManageBlogs />} /> {/* Admin dashboard */}
              <Route path="blogs-manage" element={<ManageBlogs />} /> {/* Manage blogs */}
              <Route path="blogs-create" element={<CreateBlog />} /> {/* Create blog */}
               <Route path="blogs-create-test" element={<CreateBlogTest />} /> {/* Create blog */}
              <Route path="edit-blog/:id" element={<EditBlog />} /> {/* Edit blog */}

              <Route path='comments-manage' element={<ManageComments />} />
              {/* <Route path="users" element={<ManageUsers />} /> Manage users */}
              <Route path="category" element={<CategoryManager/>} />
              <Route path="carousel" element={<CarouselAdmin/>} />
            </Route>
          </Route>

            <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
      <FloatingChat/>
    </AuthProvider>
  );
};

export default App;
